

function ChooseImage(){
  const myself = this;

  this.list = $('#js-order-choose-image');
  this.item = $('#js-order-choose-image > li');
  this.reset = $('#js-order-choose-image-reset');
  this.btn = $('#js-order-choose-image-button');
  this.href = '';
  this.type = this.list.data('type');

	this.itemNum = this.item.length;
	this.current = 0;

  this.item.on('click',function(){
    const clicknum = myself.item.index($(this));
    if(myself.current != 3 && !$(this).hasClass('active')){
        myself.check(clicknum,myself);
    }
    return false;
  });

  this.reset.on('click',function(){
      myself.resets(myself);
    return false;
  });
}

ChooseImage.prototype.check = function(_num){
  this.item.eq(_num).addClass('active');
  const num = 'num'+ (this.current + 1);
  const linkNum = _num + 1;
  this.item.eq(_num).addClass(num);
  this.current++;

  if(this.current === 3){
    this.href += linkNum+'/'+this.type;
    this.list.addClass('disabled');
    this.unlock();

  }else {
    this.href += linkNum + '-';
  }
}

ChooseImage.prototype.resets = function(){
  this.list.removeClass('disabled');
  this.item.removeClass('active');
  this.item.removeClass('num1');
  this.item.removeClass('num2');
  this.item.removeClass('num3');
  this.current = 0;
  this.lock();
}

ChooseImage.prototype.lock = function(){
  this.btn.prop("disabled", true);
  this.btn.removeClass('button--primary');
  this.btn.addClass('button--disabled');
  this.href = '';
  var text = this.btn.find('a').eq(0).data('lock');
  this.btn.find('a').text(text);
}

ChooseImage.prototype.unlock = function(){
  this.btn.prop("disabled", false);
  this.btn.removeClass('button--disabled');
  this.btn.addClass('button--primary');
  this.btn.find('a').attr('href',this.href);
  var text = this.btn.find('a').eq(0).data('unlock');
  this.btn.find('a').text(text);
}
